// extracted by mini-css-extract-plugin
export default {"header":"App_header__PKNxv","logo":"App_logo__KFImf","spacer":"App_spacer__1rWnq"};